const initialState = {
  isVisible: false,
};

export default function controlPanel(state = initialState, action) {
  switch (action.type) {
    case "TOGGLE_CONTROL_PANEL":
      return {
        isVisible: !state.isVisible,
      };
    case "SHOW_CONTROL_PANEL":
      return {
        isVisible: true,
      };
    case "HIDE_CONTROL_PANEL":
      return {
        isVisible: false,
      };
    default:
      return state;
  }
}
